export var FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';
export var FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export var FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';
export var LOGIN_USER_REQUEST = 'LOGIN_USER_REQUEST';
export var LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export var LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE';
export var LOGOUT_USER_REQUEST = 'LOGOUT_USER_REQUEST';
export var LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';
export var LOGOUT_USER_FAILURE = 'LOGOUT_USER_FAILURE';
export var FETCH_E2E_USER_REQUEST = 'FETCH_E2E_USER_REQUEST';
export var FETCH_E2E_USER_SUCCESS = 'FETCH_E2E_USER_SUCCESS';
export var FETCH_E2E_USER_FAILURE = 'FETCH_E2E_USER_FAILURE';